<i18n>
{
	"no": {
		"location": "Lokasjon",
		"title": "Hendelsesinformasjon",
		"source": "Kilde",
		"signatureName": "Signatur navn",
		"noSignature": "Ingen signatur på denne hendelsen",
		"signature": "Signatur",
		"cancel": "Lukk",
		"type": "Hendelses type",
		"edi": "EDI",
		"noEdiHasBeenSent": "Ingen EDI har blitt sendt",
		"user": "Bruker/Sjåfør",
		"receivedFrom": "EDI - Mottatt fra",
		"sentTo": "EDI - Sendt til",
		"transmission": "EDI forsendelse"
	},
	"en": {
		"location": "Location",
		"title": "Event information",
		"source": "Source",
		"signatureName": "Signature name",
		"noSignature": "No signature on this event",
		"signature": "Signature",
		"cancel": "Cancel",
		"type": "Event type",
		"edi": "EDI",
		"noEdiHasBeenSent": "No EDI has been sent",
		"user": "User/Driver",
		"receivedFrom": "EDI - Received from",
		"sentTo": "EDI - Sent to",
		"transmission": "EDI transmission"
	}
}
</i18n>
<template>
	<t-dialog
		:title="$t('title')"
		:isShown="isShown"
		:icon="'info-sign'"
		iconType="bp"
		:hasConfirm="false"
		:cancelLabel="$t('cancel')"
		@close="$emit('onClose')"
		@cancel="$emit('onCancel')"
	>
		<div class="event-grid">
			<GlobalAddressInput
				ref="location"
				:title="$t('location')"
				:value="getLocation"
				disableButtonTabbing
				:disabled="true"
			/>

			<div class="event-information">
				<t-text-input :value="event.source" :label="$t('source')" disabled/>
				<t-text-input :value="event.type" :label="$t('type')" disabled/>
				<t-text-input
					v-if="event.user"
					:value="event.user.name"
					:label="$t('user')"
					disabled
				/>
			</div>
			<t-form-group :title="$t('signature')">
				<t-text-input :value="event.signatureName" disabled/>
				<div v-if="event.signatureUrl" style="box-sizing: border-box; padding: 10px 20px; overflow:hidden; display:flex; align-items:center; justify-content: center;">
					<img style="height:200px;" :src="event.signatureUrl">
				</div>
				<t-no-content-panel
					v-else
					:text="$t('noSignature')"
					icon="edit"
					iconType="bp"
					style="height:200px"
					noBetweenGap
				/>
			</t-form-group>

			<t-form-group>
				<div v-if="event.ediTransmissionId" class="edi-content">
					<div v-if="isInbound">
						<t-text-input :value="ediLogRecord.edipartName" :label="$t('receivedFrom')" disabled/>
					</div>
					<div v-if="isOutbound">
						<t-text-input :value="ediLogRecord.edipartName" :label="$t('sentTo')" disabled/>
					</div>
					<t-text-input :value="ediLogRecord.messageType" disabled :label="$t('messageType')"  />
					<t-text-input :value="ediLogRecord.messageFormat" disabled :label="$t('messageFormat')"/>
					<t-text-input :value="getDate(ediLogRecord.sent.date)" disabled :label="$t('ediDate')"/>
					<div style="padding-top: 0.5em">
						<t-button
							iconBefore="info-sign"
							type="bp"
							appearance="primary"
							:intent="ediLogRecord.error ? 'danger' : 'success'"
							@click.native="fetchAndShowTransmission"
						>{{$t('transmission')}}</t-button>

					</div>

				</div>
				<t-no-content-panel
					v-else
					:text="$t('noEdiHasBeenSent')"
					icon="edi"
					iconType="bp"
					style="height:265px"
					noBetweenGap
				/>
					
			</t-form-group>
	
		</div>
		<InspectInboundTransmissionDialog :isShown="showInboundDialog" @close="showInboundDialog = false" />
		<InspectOutboundTransmissionDialog :isShown="showOutboundDialog" @close="showOutboundDialog = false" />
	</t-dialog>
</template>
<script>
import InspectInboundTransmissionDialog from '../../../edi/transmissionOverview/inspection/inbound/InspectInboundTransmissionDialog.vue';
import { mapActions as inboundActions } from '../../../edi/transmissionOverview/inspection/inbound/store/inbound.store';
import  { mapActions as outboundActions }  from '../../../edi/transmissionOverview/inspection/outbound/store/outbound.store';
import InspectOutboundTransmissionDialog from '../../../edi/transmissionOverview/inspection/outbound/InspectOutboundTransmissionDialog.vue';
import GlobalAddressInput from '@/modules/globalAddresses/GlobalAddressInput';
import { mapState } from '../../store/newOrder.store';
import moment from 'moment';

export default {

	components: {
		GlobalAddressInput, InspectInboundTransmissionDialog, InspectOutboundTransmissionDialog
	},
	props: {
		event: Object,
		isShown: Boolean
	},

	data() {
		return {
			showOutboundDialog: false,
			showInboundDialog: false,
		};
	},
	computed: {
		...mapState(['ediLog']),

		ediLogRecord() {
			let edi =  this.ediLog.find(x => x.transmissionId === this.event.ediTransmissionId);
			console.log(edi);
			return edi;
		},
		isInbound() {
			return this.event.source.includes('ediInbound');
		},
		isOutbound() {
			return this.event.source.includes('ediOutbound');
		},
		getLocation() {
			if (this.event && this.event.location)
				return this.event.location;
			return {
				name: '',
				street: '',
				postalCode: '',
				countryCode: '',
				postalPlace: '',
				contactEmail: ''
			};
		}
	},

	methods: {

		...inboundActions(['inspectInboundTransmission']),
		...outboundActions(['inspectOutboundTransmission']),
		getDate(date) {
			return moment(date, 'YYYYMMDDHHmm').format('YYYY-DD-MM HH:mm');
		},
		async fetchAndShowTransmission() {
			let ediLog = this.ediLogRecord;
			if (ediLog.type === 'outbound') {
				await this.inspectOutboundTransmission(ediLog.transmissionId);
				this.showOutboundDialog = true;
			} else {
				await this.inspectInboundTransmission(ediLog.transmissionId);
				this.showInboundDialog = true;
			}

		}
	}
};
</script>


<style lang="scss" scoped>

.event-grid{
	display:grid;
	column-gap: 1em;
	row-gap:1em;
	grid-template-columns: 300px 300px;
}

.event-information{
	display:grid;
	grid-template-columns: 300px;
}

</style>